/**
 * The addresses the Team member picker has found, by Team and then user id, kept for the session.
 *
 * A filter holds the people it picked by user id, and an id is not something to show anyone. The
 * Filters box builds its fields afresh each time it opens (FiltersPanel renders them under v-if),
 * so whatever a picker learned while searching is gone when the box reopens, and the page can be
 * rebuilt with a remembered filter too. The rows on screen name only people who own something in
 * them: an owner with no boards would read as "Unknown member". So the picker writes every address
 * it finds here, and starts from what is here.
 */

const LABELS_BY_TEAM: Record<string, Record<string, string>> = {};

/** The addresses known for a Team's members, as a copy: user id -> address. */
export function rememberedMemberLabels(teamId: string | null | undefined): Record<string, string> {
	return teamId ? { ...(LABELS_BY_TEAM[teamId] || {}) } : {};
}

/** Adds addresses found for a Team's members to what is known. */
export function rememberMemberLabels(teamId: string | null | undefined, labels: Record<string, string>): void {
	if (!teamId) return;
	LABELS_BY_TEAM[teamId] = { ...(LABELS_BY_TEAM[teamId] || {}), ...labels };
}

/** For specs: forget every address. */
export function forgetMemberLabels(): void {
	Object.keys(LABELS_BY_TEAM).forEach((teamId: string) => {
		delete LABELS_BY_TEAM[teamId];
	});
}
